import { useEffect, useMemo } from "react";
import { useRootStore } from "../store/contexts";
import { DynamicStore, InitializeParams } from "../store/types";

export const useStore = <T extends DynamicStore>(
  path: string,
  creator: () => T,
  initParams?: InitializeParams
): T => {
  const rootStore = useRootStore();
  const registry = rootStore.storeRegistry;

  const store = useMemo(() => {
    return registry.getStore(path, creator);
  }, [path, registry, creator]);

  useEffect(() => {
    if ('status' in store && store.status === "uninitialized" && 'initialize' in store) {
      (store as any).initialize(initParams);
    }
  }, [store, initParams]);

  useEffect(() => {
    return () => {
      registry.destroyStore(path);
    };
  }, [path, registry]);

  return store;
};
